import React, { useState } from "react"
import TransactionList from "../Componants/TransactionList"
import TransactionCard from "../Componants/TransactionCard"

const Transaction = ({handleGetOrderData}) => {
    const [filter, setFilter] = useState('All');
    return (
        <div className="flex flex-col gap-5">
            <TransactionCard filter={filter} />
            <TransactionList filter={filter} setFilter={setFilter} handleGetOrderData={handleGetOrderData}/>
        </div>
    )
}

export default Transaction